import CardMemberProfileStatus from "./CardMemberProfileStatus";

export default CardMemberProfileStatus;
